import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { useUserStore } from '@/store/index'
import routes from './webRoutes'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes
})

const whiteRoute: string[] = ['login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const token = localStorage.getItem('token')
  const userStore = useUserStore()
  let toTitle = to.meta.title ? to.meta.title : to.name
  document.title = `${toTitle}`

  if (token) {
    if (to.name === 'login') {
      next({ path: '/' })
      return
    }
    if (!userStore.name && userStore.name == undefined) {
      const data = await userStore.getUserInfo()
      data && next({ path: to.path, query: to.query })
    } else {
      next()
    }
  } else {
    if (!whiteRoute.includes(to.name as string)) {
      next({ name: 'login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

router.onError((error) => {
  NProgress.done()
})

export default router
